import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import { getFilterTable, addFilterRow, deleteFilterRow } from '../../api/recommendationAPI';
import '../Profile.css';
import { ADMIN_EMAIL } from '../../constants';

const TABLES = [
  { key: 'crowds', label: 'קהלים' },
  { key: 'types', label: 'סוגים' },
  { key: 'timings', label: 'תזמונים' },
];

const FilterColumn = ({ table, label }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState('');
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    getFilterTable(table)
      .then(data => setRows(Array.isArray(data) ? data : []))
      .catch(() => setError('שגיאה בטעינה'))
      .finally(() => setLoading(false));
  }, [table]);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async () => {
    if (!newName.trim()) return;
    setAdding(true);
    try {
      const added = await addFilterRow(table, newName.trim());
      setRows(prev => [...prev, added]);
      setNewName('');
    } catch {
      setError('שגיאה בהוספה');
    } finally {
      setAdding(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteFilterRow(table, id);
      setRows(prev => prev.filter(r => r.id !== id));
    } catch {
      setError('שגיאה במחיקה');
    }
  };

  return (
    <div className="filter-col">
      <div className="filter-col-title">{label}</div>
      {error && <div className="filter-col-error">{error}</div>}
      {loading ? (
        <div className="filter-col-loading">טוען...</div>
      ) : (
        <div className="filter-col-list">
          {rows.length === 0 && <div className="filter-col-empty">אין רשומות</div>}
          {rows.map(row => (
            <div key={row.id} className="filter-row-item">
              <span className="filter-row-name">{row.name}</span>
              <button className="filter-row-delete" onClick={() => handleDelete(row.id)}>✕</button>
            </div>
          ))}
        </div>
      )}
      <div className="filter-add-row">
        <input
          className="rec-popup-input filter-add-input"
          placeholder={`הוסף ${label}...`}
          value={newName}
          onChange={e => setNewName(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && handleAdd()}
          dir="rtl"
        />
        <button className="prog-tag-add-btn" onClick={handleAdd} disabled={adding}>
          {adding ? '...' : '+'}
        </button>
      </div>
    </div>
  );
};

const AdminFilters = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.email !== ADMIN_EMAIL) navigate('/', { replace: true });
  }, [user, navigate]);

  if (!user || user.email !== ADMIN_EMAIL) return null;

  return (
    <div className="history-page">
      <div className="filter-grid">
        {TABLES.map(t => (
          <FilterColumn key={t.key} table={t.key} label={t.label} />
        ))}
      </div>
    </div>
  );
};

export default AdminFilters;
